export default __webpack_public_path__ + "static/media/delete.904c883a.svg";